import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { service } from "../ServicesSlice";

// Models
export interface price {
    glass_id?: string,
    glass_work_id?: string,
    price: string,
}

export interface select {
    value: string | number,
    label: string
}

export interface glass {
    id: number,
    name: string,
    code: string
}

// Add material state
export interface servicePricingState {
    service?: service,
    materials: glass[],
    prices: price[],
    editId: number,
    isLoading: boolean,
    isSuccess: boolean,
    isOpen: boolean
}

const initialServicePricingState: servicePricingState = {
    prices: [{ price: "0", glass_work_id: `0` }],
    materials: [],
    editId: 0,
    isLoading: false,
    isSuccess: false,
    isOpen: false
}

// Users slice
export const servicePricingSlice = createSlice({
    name: 'service_pricing',
    initialState: initialServicePricingState,
    reducers: {
        init: state => initialServicePricingState,
        set: (state, { payload }: PayloadAction<[price]>) => {
            state.prices = [...state.prices, ...payload]
        },
        setPriceValue: (state, { payload }: PayloadAction<{ index: number, value: string }>) => {
            state.prices[payload.index].price = payload.value;
        },
        setMaterial: (state, { payload }: PayloadAction<{ index: number, value: string }>) => {
      
            state.prices[payload.index].glass_id = payload.value;
        },
        setService: (state, { payload }: PayloadAction<service>) => {
            state.service = payload;
        },
        deletePrice: (state, { payload }: PayloadAction<number>) => {
            state.prices.splice(payload, 1)
        },
        setEditId: (state, { payload }: PayloadAction<number>) => {
            state.editId = payload
        },
        setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoading = payload
        },
        setIsSuccess: (state, { payload }: PayloadAction<boolean>) => {
            state.isSuccess = payload
        },
        setIsOpen: (state, { payload }: PayloadAction<boolean>) => {
            state.isOpen = payload
        },
        addMaterials: (state, { payload }: PayloadAction<glass[]>) => {
            state.materials = payload
        },
    }
})